import { Box, Button, Tooltip, Typography, useTheme } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { EntityType, getEntityLabel } from '../util/entityLabels';

interface SourcingGridActionBarProps {
  readonly selectedCount: number;
  readonly entityType: EntityType;
  readonly listType: 'static' | 'active';
  readonly onDelete?: () => void;
  readonly onAddToList?: () => void;
}

function selectionLabel(count: number, entityType: EntityType): string {
  return `Selected ${count} ${getEntityLabel(entityType, count)}`;
}

export function SourcingGridActionBar({
  selectedCount,
  entityType,
  listType,
  onDelete,
  onAddToList,
}: SourcingGridActionBarProps) {
  const { colors } = useTheme();
  const isSelected = selectedCount > 0;
  const isPerson = entityType === 'person';

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: colors.neutral[5],
        border: `1px solid ${colors.neutral[20]}`,
        borderRadius: '0.25rem 0.25rem 0 0',
        py: '0.5rem',
        px: '1.25rem',
        overflow: 'hidden',
      }}
    >
      <Typography
        variant='body2'
        sx={{
          opacity: isSelected ? 1 : 0,
          visibility: isSelected ? 'visible' : 'hidden',
          transition: 'opacity 0.15s',
        }}
      >
        {selectionLabel(selectedCount, entityType)}
      </Typography>

      <Box
        sx={{
          display: 'flex',
          gap: '0.75rem',
          alignItems: 'center',
          opacity: isSelected ? 1 : 0,
          visibility: isSelected ? 'visible' : 'hidden',
          transition: 'opacity 0.15s',
        }}
      >
        {listType === 'static' && (
          <Button
            variant='outlined'
            color='secondary'
            size='small'
            startIcon={<DeleteOutlineIcon />}
            onClick={onDelete}
          >
            Delete
          </Button>
        )}

        <Tooltip title={isPerson ? 'Coming soon' : ''}>
          <span>
            <Button
              variant='contained'
              color='secondary'
              size='small'
              startIcon={<AddIcon />}
              disabled={isPerson}
              onClick={onAddToList}
            >
              Add to List
            </Button>
          </span>
        </Tooltip>
      </Box>
    </Box>
  );
}
